import React from "react"
//import I18n from "i18n-js/index.js.erb"

class GuestTypeSelect extends React.Component {

  constructor(props) {
    super(props);
    this.processGuestType = this.processGuestType.bind(this)
  }

  componentDidUpdate(prevProps) {
    if(this.props.guest_type === null && prevProps.guest_type != null) {
      $(this.refs.guest_types).val("").trigger('change')
    }
  }

  componentDidMount () {
    var self = this;
    var data = []
    if (this.props.all_guest_types && this.props.all_guest_types.length) {
      this.props.all_guest_types.map((guest_type) => {
        data.push({"id": guest_type.id, "text": guest_type.name, "selected": this.props.guest_type && this.props.guest_type.id === guest_type.id ? true : false})
      })
    }

    if (this.refs.guest_types) {
      $(this.refs.guest_types).select2({
        data: data,
        allowClear: false,
        minimumResultsForSearch: Infinity,
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (guest_type) {
          return self.processGuestType(guest_type)
        },
        templateSelection: function (guest_type) {
          if (guest_type && guest_type.id != null && guest_type.id != '') {
            self.props.onChange(guest_type);

            return self.processGuestType(guest_type);
          } else {
            return guest_type.text;
          }
        }
      }).on('select2:unselect', function () {
        self.props.onChange(null);
      }).on('select2:select', function(selection) {
        self.props.onChange(selection.params.data);
      });
    }
  }

  render() {
    return (
      <select className="form-control" ref="guest_types" style={{width: '100%', minHeight: 33}}>
        <option></option>
      </select>
    );
  }

  processGuestType(guest_type) {
    return guest_type.text
  }

}

export default GuestTypeSelect